export const parseNumber = (value: any) => {
    if (value === "" || value == null) {
        return null;
    }

    const normalized = String(value).replace(",", ".");

    const n = Number(normalized);

    return isFinite(n) ? n : null;
};